class TextBlockReadMore extends HTMLElement {
  constructor() {
    super();
    this._hasConnected = false;
    this._boundToggle = this.toggle.bind(this);
  }

  connectedCallback() {
    if (this._hasConnected) return;
    this._hasConnected = true;

    this.readMoreBtn = this.querySelector('[data-read-more]');
    if (!this.readMoreBtn) return;

    this.shortContent = this.querySelector('[data-content-short]');
    this.fullContent = this.querySelector('[data-content-full]');
    this.readMoreText = this.readMoreBtn.querySelector('[data-read-more-text]');

    this.readMoreBtn.addEventListener('click', this._boundToggle);
  }

  toggle() {
    const isExpanded = this.readMoreBtn.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.shortContent.style.display = '';
      this.fullContent.style.display = 'none';
      this.readMoreText.textContent = 'Read more';
      this.readMoreBtn.setAttribute('aria-expanded', 'false');
    } else {
      this.shortContent.style.display = 'none';
      this.fullContent.style.display = 'block';
      this.readMoreText.textContent = 'Read less';
      this.readMoreBtn.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('text-block-read-more')) {
  customElements.define('text-block-read-more', TextBlockReadMore);
}
